var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 2 }
            },
            [
              _c("el-step", {
                attrs: {
                  title:
                    _vm.transportTypeCode == "KY"
                      ? _vm.$t("i18n_Air_Freight_Information")
                      : _vm.transportTypeCode == "HY"
                      ? _vm.$t("i18n_ocean_freight_information")
                      : _vm.transportTypeCode == "LY"
                      ? _vm.$t("i18n_land_transportation_information")
                      : ""
                }
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_Value_added_service") }
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_shipping_information") }
              }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: _vm.$t("i18n_confirm_order") } }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_order_completed") }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "center_wrap" },
      [
        _c("div", { staticClass: "wrap_l" }, [
          _c("div", {
            staticStyle: { display: "-webkit-flex", "align-items": "center" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "-webkit-flex",
                    "align-items": "center",
                    "margin-bottom": "20px"
                  }
                },
                [
                  _c("img", {
                    attrs: { src: require("../../assets/weituo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "tittype" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_Order_info")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": _vm.labelPosition,
                        "label-width": "110px"
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_contact_person") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerContact",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerContact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_contact_number") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerTel",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.todoordate
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("i18n_pickup_time") }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      disabled: "",
                                      placeholder: _vm.$t("i18n_please_choose"),
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value: _vm.todoordate,
                                      callback: function($$v) {
                                        _vm.todoordate = $$v
                                      },
                                      expression: "todoordate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.todoordate
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("i18n_shipment_arrival_time"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: _vm.$t("i18n_please_choose"),
                                      "picker-options": _vm.pickerSetTime
                                    },
                                    model: {
                                      value: _vm.inwarehousetime,
                                      callback: function($$v) {
                                        _vm.inwarehousetime = $$v
                                      },
                                      expression: "inwarehousetime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "ASN" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("i18n_please_enter")
                                },
                                model: {
                                  value: _vm.asn,
                                  callback: function($$v) {
                                    _vm.asn = $$v
                                  },
                                  expression: "asn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.countLIst_T.name != "",
                  expression: "countLIst_T.name != ''"
                }
              ],
              staticClass: "Item_list"
            },
            [
              _c(
                "div",
                {
                  staticClass: "LR_center",
                  staticStyle: {
                    display: "-webkit-flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", { staticClass: "count_center" }, [
                    _c("img", {
                      attrs: { src: require("../../assets/tihuo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "tittype",
                        staticStyle: { color: "#333" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_Pickup_Information")) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "padding-left": "30px",
                    "box-sizing": "border-box"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.countLIst_T.name,
                          expression: "countLIst_T.name"
                        }
                      ],
                      staticClass: "thatpoperWrap",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [
                      _c("div", { staticClass: "popWrap_l" }, [
                        _c("p", { staticClass: "lianxiren" }, [
                          _vm._v(_vm._s(_vm.countLIst_T.name))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-left": "12px" } }, [
                          _vm._v(_vm._s(_vm.countLIst_T.tel))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "overText",
                            staticStyle: { "margin-left": "20px" }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.countLIst_T.parvince) +
                                _vm._s(_vm.countLIst_T.city) +
                                _vm._s(_vm.countLIst_T.area) +
                                _vm._s(_vm.countLIst_T.address) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showTi,
                            expression: "showTi"
                          }
                        ]
                      },
                      _vm._l(_vm.TipopList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "poperWrap",
                            staticStyle: { "margin-top": "20px" },
                            on: {
                              click: function($event) {
                                return _vm.changeTiitem(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "popWrap_l" }, [
                              _c("p", { staticClass: "lianxiren" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "margin-left": "12px" } },
                                [_vm._v(_vm._s(item.tel))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "overText",
                                  staticStyle: { "margin-left": "20px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.parvince) +
                                      _vm._s(item.city) +
                                      _vm._s(item.area) +
                                      _vm._s(item.address) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "popWrap_R" },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.isdefault,
                                        expression: "item.isdefault"
                                      }
                                    ],
                                    staticClass: "morentype"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("i18n_default_address"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.isdefault,
                                        expression: "!item.isdefault"
                                      }
                                    ],
                                    staticStyle: { color: "#5ab53c" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.changeshowType(
                                          2,
                                          item,
                                          "ajax"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("i18n_set_to_default_address")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#5ab53c" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.UpItem(2, item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "LR_center",
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", { staticClass: "count_center" }, [
                  _c("img", {
                    attrs: { src: require("../../assets/fahuo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "tittype" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_Shipper_Information")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticStyle: { float: "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#604aff" },
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.addNewpop(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Add_consignor")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countLIst_S.name == "",
                        expression: "countLIst_S.name == ''"
                      }
                    ],
                    staticClass: "poperWrap"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("i18n_No_default_contact")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countLIst_S.name,
                        expression: "countLIst_S.name"
                      }
                    ],
                    staticClass: "thatpoperWrap",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c("div", { staticClass: "popWrap_l" }, [
                      _c("p", { staticClass: "lianxiren" }, [
                        _vm._v(_vm._s(_vm.countLIst_S.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-left": "12px" } }, [
                        _vm._v(_vm._s(_vm.countLIst_S.tel))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "overText",
                          staticStyle: { "margin-left": "20px" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.countLIst_S.parvince) +
                              " " +
                              _vm._s(_vm.countLIst_S.city) +
                              "\n                " +
                              _vm._s(_vm.countLIst_S.area) +
                              " " +
                              _vm._s(_vm.countLIst_S.address) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "popWrap_R" },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.countLIst_S.isdefault,
                                expression: "countLIst_S.isdefault"
                              }
                            ],
                            staticClass: "morentype"
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_default_address")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.countLIst_S.isdefault,
                                expression: "!countLIst_S.isdefault"
                              }
                            ],
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.changeshowType(
                                  1,
                                  _vm.countLIst_S,
                                  "loca"
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("i18n_set_to_default_address"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.UpItem(1, _vm.countLIst_S)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showFa,
                          expression: "showFa"
                        }
                      ]
                    },
                    _vm._l(_vm.FapopList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "poperWrap",
                          staticStyle: { "margin-top": "20px" },
                          on: {
                            click: function($event) {
                              return _vm.changeFAitem(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(item.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.parvince) +
                                    " " +
                                    _vm._s(item.city) +
                                    " " +
                                    _vm._s(item.area) +
                                    "\n                    " +
                                    _vm._s(item.address) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "popWrap_R" },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.isdefault,
                                      expression: "item.isdefault"
                                    }
                                  ],
                                  staticClass: "morentype"
                                },
                                [_vm._v(_vm._s(_vm.$t("i18n_default_address")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.isdefault,
                                      expression: "!item.isdefault"
                                    }
                                  ],
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changeshowType(1, item, "ajax")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("i18n_set_to_default_address")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.UpItem(1, item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.FapopList.length > 1,
                    expression: "FapopList.length > 1"
                  }
                ],
                staticStyle: { margin: "10px 0 0 30px" }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#9a9a9a" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        return _vm.openmo1()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          _vm.showFa
                            ? "i18n_Collapse"
                            : "i18n_More_consignor_information"
                        )
                      )
                    )
                  ]
                ),
                _c("span", {
                  class: _vm.showFa ? "el-icon-arrow-up" : "el-icon-arrow-down"
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          this.isGlobalDelivery
            ? _c("div", { staticClass: "Item_list" }, [
                _c(
                  "div",
                  {
                    staticClass: "LR_center",
                    staticStyle: {
                      display: "-webkit-flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", { staticClass: "count_center" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/fahuo.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "tittype" }, [
                        _vm._v(_vm._s(_vm.$t("i18n_consignee_information")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.addNewpop(3)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_new_recevier_address")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "padding-left": "30px",
                      "box-sizing": "border-box"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.countLIst_C.name == "",
                            expression: "countLIst_C.name == ''"
                          }
                        ],
                        staticClass: "poperWrap"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("i18n_No_contact")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.countLIst_C.name,
                            expression: "countLIst_C.name"
                          }
                        ],
                        staticClass: "thatpoperWrap",
                        staticStyle: { "margin-top": "20px" }
                      },
                      [
                        _c("div", { staticClass: "popWrap_l" }, [
                          _c("p", { staticClass: "lianxiren" }, [
                            _vm._v(_vm._s(_vm.countLIst_C.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "margin-left": "12px" } }, [
                            _vm._v(_vm._s(_vm.countLIst_C.tel))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "overText",
                              staticStyle: { "margin-left": "20px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.countLIst_C.country) +
                                  " " +
                                  _vm._s(_vm.countLIst_C.city) +
                                  "\n                " +
                                  _vm._s(_vm.countLIst_C.area) +
                                  " " +
                                  _vm._s(_vm.countLIst_C.address) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "popWrap_R" },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#604aff" },
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.UpItem(3, _vm.countLIst_C)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-collapse-transition", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSh,
                              expression: "showSh"
                            }
                          ]
                        },
                        _vm._l(_vm.SHpopList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "poperWrap",
                              staticStyle: { "margin-top": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.changeShitem(item)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "popWrap_l" }, [
                                _c("p", { staticClass: "lianxiren" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-left": "12px" } },
                                  [_vm._v(_vm._s(item.tel))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.parvince) +
                                        " " +
                                        _vm._s(item.city) +
                                        " " +
                                        _vm._s(item.area) +
                                        "\n                    " +
                                        _vm._s(item.address) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "popWrap_R" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.UpItem(3, item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.SHpopList.length > 1,
                        expression: "SHpopList.length > 1"
                      }
                    ],
                    staticStyle: { margin: "10px 0 0 30px" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#9a9a9a" },
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.openmo3()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.showSh
                                ? "i18n_Collapse"
                                : "i18n_more_consignee_information"
                            )
                          )
                        )
                      ]
                    ),
                    _c("span", {
                      class: _vm.showSh
                        ? "el-icon-arrow-up"
                        : "el-icon-arrow-down"
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "LR_center",
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", { staticClass: "count_center" }, [
                  _c("img", {
                    attrs: { src: require("../../assets/shouhuo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "tittype" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("i18n_FBA_facility_warehosue_information")
                        ) +
                        "\n            "
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.toFABck.namec,
                        expression: "toFABck.namec"
                      }
                    ],
                    staticClass: "thatpoperWrap",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c("div", { staticClass: "popWrap_l" }, [
                      _c("p", { staticClass: "lianxiren" }, [
                        _vm._v(_vm._s(_vm.toFABck.namec))
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "overText",
                          staticStyle: { "margin-left": "20px" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.toFABck.address) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          !_vm.THFdata.checked
            ? _c(
                "div",
                { staticClass: "Item_list", staticStyle: { padding: "0" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "LR_center",
                      staticStyle: {
                        display: "-webkit-flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            background: "#ffe9c7",
                            padding: "8px 30px"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "tittype",
                              staticStyle: {
                                padding: "0 5px",
                                color: "#c19822",
                                "font-size": "16px"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "i18n_Please_ship_your_package_to_below_warehouse"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%", "box-sizing": "border-box" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "thatpoperWrap",
                          staticStyle: {
                            padding: "30px 50px",
                            border: "none",
                            background: "#ffffff"
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(_vm.fromFABck.namec))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(_vm.fromFABck.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.fromFABck.country) +
                                    _vm._s(_vm.fromFABck.addressc) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.PSFmoney.checked
            ? _c(
                "div",
                { staticClass: "Item_list", staticStyle: { padding: "0" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "LR_center",
                      staticStyle: {
                        display: "-webkit-flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            background: "#ffe9c7",
                            padding: "8px 30px"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "tittype",
                              staticStyle: {
                                padding: "0 5px",
                                color: "#c19822",
                                "font-size": "16px"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "i18n_pickup_cargo_at_below_warehouse"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%", "box-sizing": "border-box" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "thatpoperWrap",
                          staticStyle: {
                            padding: "30px 50px",
                            border: "none",
                            background: "#ffffff"
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(_vm.description.namec))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(_vm.description.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.description.country) +
                                    _vm._s(_vm.description.addressc) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "LR_center",
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", { staticClass: "count_center" }, [
                  _c("img", {
                    attrs: { src: require("../../assets/ps.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "tittype" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_remark")))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c("div", { staticStyle: { "margin-top": "20px" } }, [
                  _c(
                    "div",
                    { staticClass: "popWrap_l" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          staticStyle: { width: "100%" },
                          attrs: { "label-width": "120px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("i18n_delivery_remark") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.delgoodsremarks,
                                  callback: function($$v) {
                                    _vm.delgoodsremarks = $$v
                                  },
                                  expression: "delgoodsremarks"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_pickup_remark") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.recgoodremarks,
                                  callback: function($$v) {
                                    _vm.recgoodremarks = $$v
                                  },
                                  expression: "recgoodremarks"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.THFdata.checked
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("i18n_pickup_remark") }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.getgoodsremarks,
                                      callback: function($$v) {
                                        _vm.getgoodsremarks = $$v
                                      },
                                      expression: "getgoodsremarks"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_Clients_tracking_number")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.customerNo,
                                  callback: function($$v) {
                                    _vm.customerNo = $$v
                                  },
                                  expression: "customerNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_cost_calculation")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "OrderDetails" }, [
              _c(
                "div",
                {
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_shipping_cost")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.FBATransmoney.goodsTypeFeeDTOS, function(
                    item,
                    index
                  ) {
                    return _c("p", { key: index, staticClass: "coutText" }, [
                      _c("span", { staticClass: "littit" }, [
                        _vm._v(_vm._s(item.goodsTypeName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fontString" }, [
                        _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("(" + _vm._s(item.calDesc) + ")")
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.FBATransmoney.currency) +
                          _vm._s(_vm.FBATransmoney.amount)
                      )
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.THFdata.checked,
                      expression: "THFdata.checked"
                    }
                  ],
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_pickup_fee")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_pickup_at_original_port")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.THFdata.currency) +
                          _vm._s(_vm.THFdata.amount)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.THFdata.maxKilometer > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "littit",
                            staticStyle: { float: "left", width: "100%" }
                          },
                          [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.THFdata.minKilometer) +
                                "--" +
                                _vm._s(_vm.THFdata.maxKilometer) +
                                ")\n              " +
                                _vm._s(_vm.$t("i18n_Kilometers"))
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.formData.totalExpense
                ? _c(
                    "div",
                    { staticClass: "Item_Right" },
                    [
                      _c("p", { staticClass: "tit" }, [
                        _vm._v(_vm._s(_vm.$t("i18n_Value_Added_Service_Fee")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.formData.feeItemDTOS, function(item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.checked,
                                expression: "item.checked"
                              }
                            ],
                            key: index,
                            staticClass:
                              "coutText animate__animated animate__bounceInRight"
                          },
                          [
                            item.feeCode === "CLEF"
                              ? _c("span", { staticClass: "littit" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "i18n_customs_declaration_with_tax_refund"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", { staticClass: "littit" }, [
                                  _vm._v(_vm._s(item.feeName))
                                ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "fontString" }, [
                              _vm._v(
                                _vm._s(item.currency) +
                                  "  " +
                                  _vm._s(item.amount) +
                                  "  (" +
                                  _vm._s(item.calDesc) +
                                  ")"
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "coutText animate__animated animate__bounceInRight",
                          staticStyle: { color: "#ff3030" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "littit",
                              staticStyle: { color: "#ff3030" }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_subtotal")) + ":")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "fontString" }, [
                            _vm._v(_vm._s(_vm.formData.totalExpense))
                          ])
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "Item_Right" }, [
                _c(
                  "p",
                  {
                    staticClass: "coutText",
                    staticStyle: {
                      "justify-content": "flex-start",
                      gap: "10px"
                    }
                  },
                  [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_total_cost")))
                    ]),
                    _vm._v(" "),
                    _vm._l(this.newArray, function(item, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.amount > 0,
                              expression: "item.amount > 0"
                            }
                          ],
                          key: index
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.currency != "",
                                    expression: "item.currency != ''"
                                  }
                                ],
                                staticClass: "fontString"
                              },
                              [_vm._v(_vm._s(item.currency))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.amount > 0,
                                    expression: "item.amount > 0"
                                  }
                                ],
                                staticClass: "fontString",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px"
                                }
                              },
                              [_vm._v(_vm._s(item.amount))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    index == _vm.newArray.length - 1
                                      ? false
                                      : true,
                                  expression:
                                    "index == newArray.length - 1 ? false : true"
                                }
                              ]
                            },
                            [_vm._v("+")]
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_Covert_to_CNY")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "goodsValueCount" }, [
                _c("div", { staticClass: "goodsValue_name" }, [
                  _vm._v("货值统计")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "goodsValue_fat" }, [
                  _c("div", { staticClass: "goodsValue_box" }, [
                    _vm._v("箱数:" + _vm._s(_vm.getBoxNum) + " 箱")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "goodsValue_value" }, [
                    _vm._v("货值:" + _vm._s(_vm.getGoodsValue) + " USD")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "margin-top": "30px",
                  float: "left"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.pathToback()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Previousstep")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "100%",
                          background: "#5ab53c",
                          color: "#ffffff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pathToNext()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Next_step")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticClass: "dialog",
            attrs: {
              width: _vm.width,
              visible: _vm.dialogTableVisible,
              closeOnClickModal: false
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogTableVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "wrap_count" }, [
              _c("div", { staticClass: "header_logo" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        !this.itemid
                          ? "i18n_Create_new_address"
                          : "i18n_Modify_Address"
                      )
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "count" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": _vm.labelPosition,
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("i18n_contact_person") } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.addPls("i18n_Name", "input")
                            },
                            model: {
                              value: _vm.fromPop.name,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "name", $$v)
                              },
                              expression: "fromPop.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("i18n_contact_info") } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "30",
                              "show-word-limit": "",
                              placeholder: _vm.addPls(
                                "i18n_contact_info",
                                "input"
                              )
                            },
                            model: {
                              value: _vm.fromPop.tel,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "tel", $$v)
                              },
                              expression: "fromPop.tel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum == 1 || _vm.changeNum == 2,
                              expression: "changeNum == 1 || changeNum == 2"
                            }
                          ],
                          attrs: { label: _vm.$t("i18n_contact_address") }
                        },
                        [
                          _c("el-cascader", {
                            ref: "refSsqname",
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.Guojialist,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.changessq },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.namec))]),
                                    _vm._v(" "),
                                    !node.isLeaf ? _c("span") : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.ssqnames,
                              callback: function($$v) {
                                _vm.ssqnames = $$v
                              },
                              expression: "ssqnames"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum == 3,
                              expression: "changeNum == 3"
                            }
                          ],
                          attrs: { label: _vm.$t("i18n_contact_address") }
                        },
                        [
                          _c("el-cascader", {
                            ref: "refSsqname",
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.citylist,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.changessq },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.namec))]),
                                    _vm._v(" "),
                                    !node.isLeaf ? _c("span") : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.ssqnames,
                              callback: function($$v) {
                                _vm.ssqnames = $$v
                              },
                              expression: "ssqnames"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "i18n_please_enter_the_detailed_location"
                              ),
                              type: "textarea"
                            },
                            model: {
                              value: _vm.fromPop.address,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "address", $$v)
                              },
                              expression: "fromPop.address"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "type" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.changeNum != 3,
                                  expression: "changeNum != 3"
                                }
                              ],
                              model: {
                                value: _vm.fromPop.isdefault,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "isdefault", $$v)
                                },
                                expression: "fromPop.isdefault"
                              }
                            },
                            [
                              _c("el-checkbox", { attrs: { name: "type" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("i18n_set_to_default_address"))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmit }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.itemid
                                      ? "i18n_edit"
                                      : "i18n_confirm_addition"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialogTableVisible = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_cancel")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46509e7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46509e7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBAorder/Fbaconsignment.vue
// module id = null
// module chunks = 